module.exports = __webpack_public_path__ + "static/media/crowd.8c9bd99b.mp3";